import { Get, Set } from "../../../../../Request";
import { useState } from "react";
export const useClassList = () => {
  const [loading, setLoading] = useState({
    listLoading: false,
    createLoading: false,
  });
  const [data, setData] = useState({});

  const getData = classmanager_id => {
    setLoading({ ...loading, listLoading: true });
    Get({
      url: "/class/classmanger_class",
      data: { classmanager_id },
    }).then(res => {
      setLoading({ ...loading, listLoading: false });
      setData(res);
    });
  };

  const formSubmit = data => {
    setLoading({ ...loading, createLoading: true });
    Set({
      url: "/class/create_admin",
      data: data,
    }).then(() => {
      setLoading({ ...loading, createLoading: false });
    });
  };
  const deleteClass = (class_id, classmanager_id) => {
    setLoading({ ...loading, listLoading: true });
    Set({
      url: "/class/destroy_class",
      data: { class_id },
    }).then(() => {
      getData(classmanager_id);
    });
  };
  return { data, loading, getData, formSubmit, deleteClass };
};

export const useGetData = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState({});
  const GetData = async () => {
    setloading(true);
    Get({
      url: "/item/nes_data",
    }).then(res => {
      setData(res);
      setloading(false);
    });
  };
  return { GetData, data, loading };
};
export const useEditClass = id => {
  const [loading, setloading] = useState(false);
  const [step, setstep] = useState(1);
  const [Data, setData] = useState([]);
  const formSubmit = async data => {
    setloading(true);
    Set({
      url: "/class/update_details",
      data: { ...data, ...{ class_id: id } },
    }).then(res => {
      setloading(false);
    });
  };
  const updateTeachers = async data => {
    setloading(true);
    Set({
      url: "/class/update_teachers",
      data: { ...data, ...{ class_id: id } },
    }).then(res => {
      setstep(1);
      setloading(false);
    });
  };
  const getTag = () => {
    setloading(true);

    Get({
      url: "/tag/show_list",
    }).then(res => {
      setData(res);
      return res;
    });
  };

  return { formSubmit, Data, loading, getTag, updateTeachers, step, setstep };
};

export const useSingleData = () => {
  const [loading, setLoading] = useState(true);
  const [Data, setData] = useState({});
  const getData = slug => {
    setLoading(true);

    Get({
      url: "/class/single",
      data: {
        slug,
      },
    }).then(res => {
      setLoading(false);

      setData(res);
    });
  };
  return { Data, loading, getData };
};
